import React, { Component } from 'react';
import DiagramUtils from "../../utils/DiagramUtils";

export default class Adorner extends Component {

    state = {
    };

    style = ""

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

        this.designer = this.props.designer;
        const c = this.props.model;
        c._sys.designer = this.designer;

        this.unregisterResolutionChangedListener = this.designer.registerResolutionChangedListener(c => {
            this.updateLayout();
        });
        this.unregisterExtentChangedListener = this.designer.registerExtentChangedListener(c => {
            this.updateLayout();
        });
        this.unregisterPropertyChangedListener = this.props.model.registerPropertyChangedListener((name, valOld, valNew) => {
            this.updateLayout();
        })

        setTimeout(() => {
            this.dom = document.getElementById(`adorner-${this.props.id}`);
            if (!this.dom)
                return;

            this.props.model._sys.dom = this.dom;
            this.dom.setAttribute("style", this.style);
            this.updateLayout();
        }, 0);
    }

    componentWillUnmount() {
        this.unregisterResolutionChangedListener();
        this.unregisterExtentChangedListener();
        this.unregisterPropertyChangedListener();
    }

    updateLayout() {

        const extent = this.designer.extent;
        const resolution = this.designer.resolution;
        let { x, y, width, height, scale } = this.props.model;

        let sx = (x - extent.left) / resolution - 1;
        let sy = (y - extent.top) / resolution - 1;

        let sw = width.getActualLength() / resolution * scale + 2;
        let sh = height.getActualLength() / resolution * scale + 2;

        this.style = `left: ${sx}px; top: ${sy}px; width: ${sw}px; height: ${sh}px;`;
        if (!this.dom)
            return;

        this.dom.setAttribute("style", this.style);
    }

    renderUI(model) {
        const diagrams = DiagramUtils.diagrams;
        const modelInfo = diagrams[model.getType()];
        const ui = modelInfo ? modelInfo.uiGetter(model) : null;
        return ui;
    }

    render() {

        return (
            <div id={`adorner-${this.props.id}`} className={"adorner " + (this.props.className || "")}>
                {this.renderUI(this.props.model)}
            </div>
        );
    }
}
